import React from 'react';
import './Reviews.sass';

import FeatureText from '../featureText/FeatureText';
import Button from '../button/Button';

import {FormattedMessage} from 'react-intl';
import ReviewsTotal from './ReviewsTotal';
import ChannelLink from '../../containers/channelUtils/ChannelLink';

export default function Reviews({orderCount}) {
  return (
    <section className="reviews">
      <div className="reviews__row">
        <div className="reviews__widget-col">
          <div className="reviews__widget">
            <div className="reviews__ribbon">
              <ReviewsTotal vertical />
            </div>

            <hr className="reviews__divider"/>

            <div className="reviews__counter">
              <div className="reviews__completed">
                {orderCount != null && orderCount.toString().split('').map((digit, idx) => (
                  <span key={idx} className="reviews__number">{digit}</span>
                ))}
              </div>

              <p className="reviews__completed-orders">
                <FormattedMessage id="section.reviews.completed"/>
              </p>
              <p className="reviews__grey">
                <FormattedMessage id="section.reviews.counting"/>
              </p>
            </div>
          </div>
        </div>

        <div className="reviews__text">
          <FeatureText
            reviews
            swapped
            header={<FormattedMessage id="section.reviews.title"/>}
            subheader={<FormattedMessage id="section.reviews.address"/>}
            text={<FormattedMessage id="section.reviews.description"/>}
          >
            <Button
              filled
              big
              component={ChannelLink}
              to="/reviews"
            >
              <FormattedMessage id="section.reviews.read"/>
            </Button>
          </FeatureText>
        </div>
      </div>
    </section>
  );
}



// WEBPACK FOOTER //
// ./components/reviews/Reviews.js